import type { Namespace } from './types';
export const zh: Namespace = {
  common: {
    collapse: '收起侧栏',
    expand: '展开侧栏',
    loading: '加载中…',
    retry: '重试',
    cancel: '取消',
    confirm: '确定',
    refresh: '刷新',
    back: '返回',
    actions: '操作',
    search: '查询',
    reset: '重置',
    createdAt: '创建时间',
    listTotal: '共 {{count}} 条',
    amountUnits: {
      USD: '美元',
      EUR: '欧元',
      CNY: '人民币',
      GBP: '英镑',
      CHF: '瑞士法郎',
      RUB: '俄罗斯卢布',
      PLN: '波兰兹罗提',
      BRL: '巴西雷亚尔',
      JPY: '日元',
      NOK: '挪威克朗',
      IDR: '印尼盾',
      MYR: '马来西亚林吉特',
      PHP: '菲律宾比索',
      SGD: '新加坡元',
      THB: '泰铢',
      VND: '越南盾',
      KRW: '韩元',
      TRY: '土耳其里拉',
      UAH: '乌克兰格里夫纳',
      MXN: '墨西哥比索',
      CAD: '加元',
      AUD: '澳元',
      NZD: '新西兰元',
      INR: '印度卢比',
      CLP: '智利比索',
      PEN: '秘鲁索尔',
      COP: '哥伦比亚比索',
      ZAR: '南非兰特',
      HKD: '港币',
      TWD: '新台币',
      SAR: '沙特里亚尔',
      AED: '阿联酋迪拉姆',
      SEK: '瑞典克朗',
      ARS: '阿根廷比索',
      ILS: '以色列谢克尔',
      BYN: '白俄罗斯卢布',
      KZT: '哈萨克斯坦坚戈',
      KWD: '科威特第纳尔',
      QAR: '卡塔尔里亚尔',
      CRC: '哥斯达黎加科朗',
      UYU: '乌拉圭比索',
      BGN: '保加利亚列弗',
      HRK: '克罗地亚库纳',
      CZK: '捷克克朗',
      DKK: '丹麦克朗',
      HUF: '匈牙利福林',
      RON: '罗马尼亚列伊',
    },
  },
  nav: {
    groupOverview: '概览',
    groupSteam: 'steam',
    steamOrders: '订单',
    redeems: '兑换记录',
    proxies: '代理',
    cdkeys: 'CDKey',
    fxQuotes: '汇率报价',
    users: '用户',
    settings: '个人设置',
    logout: '退出登录',
  },
  errors: {
    internal: '系统内部错误',
    validation: '请求不合法',
    notFound: '对象不存在',
    conflict: '与现有数据冲突',
    accountWrongState: '账号当前状态不允许该操作（可能离线），请先登录',
    unauthenticated: '未登录或登录已过期',
    forbidden: '没有权限',
    rateLimited: '操作过于频繁，请稍后再试',
    dependencyUnavailable: '依赖服务暂不可用',
    transport: '网络异常，请检查连接',
    unknown: '未知错误',
  },
  mutation: {
    partialFailed: '{{count}} 项失败',
    overflow: '另有 {{count}} 项未显示',
  },
  reasonCodes: {
    account_banned: '账号被封禁',
    account_disabled: '账号已停用',
    account_limited: '账号受限',
    account_locked: '账号已被锁定',
    busy: '服务繁忙',
    captcha_required: '需要图形验证码',
    credentials_empty: '凭据为空',
    credentials_invalid: '凭据无效',
    duplicate_request: '重复请求',
    fx_refresh_db_write_failed: '汇率写入数据库失败',
    fx_refresh_http_failed: '汇率接口请求失败',
    guard_2fa_code: '需要令牌验证码',
    guard_code_invalid: '验证码无效',
    guard_device_confirm: '需到 Steam App 确认登录',
    guard_email_code: '需要邮箱验证码',
    guard_email_confirm: '需到邮箱确认登录',
    invalid_argument: '请求参数不合法',
    invalid_response: '响应异常',
    ip_banned: '出口 IP 被封',
    login_throttled: '登录被风控节流',
    network_unreachable: '网络不可达',
    no_credentials: '没有可用的会话凭据（需重登）',
    no_proxy_available: '没有可用代理',
    not_logged_on: '账号未登录',
    pending: '处理中',
    rate_limited: '触发限流',
    settle_refused: '结算被拒绝',
    ssrf_blocked: '请求被安全策略拦截',
    transport_error: '传输失败',
    transport_timeout: '传输超时',
    unavailable: '服务不可用',
    unknown: 'Steam 返回未识别的错误码',
  },
  range: {
    today: '今天',
    d7: '近 7 天',
    d30: '近 30 天',
    d90: '近 90 天',
    all: '全部时间',
    from: '开始日期',
    to: '结束日期',
  },
  stats: {
    title: '统计概览',
    totalScope: '共 {{count}} 条',
    loadFailed: '统计加载失败',
  },
  selectionBar: {
    idle: '未选中',
    clear: '清空选择',
    ariaLabel: '批量操作',
  },
  app: {
    title: 'Steam 管理平台',
    notFound: '页面不存在',
    forbidden: '无权访问',
    theme: '主题',
    light: '浅色',
    dark: '深色',
    system: '跟随系统',
    language: '语言',
  },
};

export const en: Namespace = {
  common: {
    collapse: 'Collapse sidebar',
    expand: 'Expand sidebar',
    loading: 'Loading…',
    retry: 'Retry',
    cancel: 'Cancel',
    confirm: 'OK',
    refresh: 'Refresh',
    back: 'Back',
    actions: 'Actions',
    search: 'Search',
    reset: 'Reset',
    createdAt: 'Created at',
    listTotal: '{{count}} total',
    amountUnits: {
      USD: 'US Dollar',
      EUR: 'Euro',
      CNY: 'Chinese Yuan',
      GBP: 'British Pound',
      CHF: 'Swiss Franc',
      RUB: 'Russian Ruble',
      PLN: 'Polish Zloty',
      BRL: 'Brazilian Real',
      JPY: 'Japanese Yen',
      NOK: 'Norwegian Krone',
      IDR: 'Indonesian Rupiah',
      MYR: 'Malaysian Ringgit',
      PHP: 'Philippine Peso',
      SGD: 'Singapore Dollar',
      THB: 'Thai Baht',
      VND: 'Vietnamese Dong',
      KRW: 'South Korean Won',
      TRY: 'Turkish Lira',
      UAH: 'Ukrainian Hryvnia',
      MXN: 'Mexican Peso',
      CAD: 'Canadian Dollar',
      AUD: 'Australian Dollar',
      NZD: 'New Zealand Dollar',
      INR: 'Indian Rupee',
      CLP: 'Chilean Peso',
      PEN: 'Peruvian Sol',
      COP: 'Colombian Peso',
      ZAR: 'South African Rand',
      HKD: 'Hong Kong Dollar',
      TWD: 'New Taiwan Dollar',
      SAR: 'Saudi Riyal',
      AED: 'UAE Dirham',
      SEK: 'Swedish Krona',
      ARS: 'Argentine Peso',
      ILS: 'Israeli New Shekel',
      BYN: 'Belarusian Ruble',
      KZT: 'Kazakhstani Tenge',
      KWD: 'Kuwaiti Dinar',
      QAR: 'Qatari Riyal',
      CRC: 'Costa Rican Colon',
      UYU: 'Uruguayan Peso',
      BGN: 'Bulgarian Lev',
      HRK: 'Croatian Kuna',
      CZK: 'Czech Koruna',
      DKK: 'Danish Krone',
      HUF: 'Hungarian Forint',
      RON: 'Romanian Leu',
    },
  },
  nav: {
    groupOverview: 'Overview',
    groupSteam: 'Steam',
    steamOrders: 'Orders',
    redeems: 'Redemptions',
    proxies: 'Proxies',
    cdkeys: 'CDKeys',
    fxQuotes: 'Fx Quotes',
    users: 'Users',
    settings: 'Settings',
    logout: 'Sign out',
  },
  errors: {
    internal: 'Internal server error',
    validation: 'Invalid request',
    notFound: 'Not found',
    conflict: 'Conflicts with existing data',
    accountWrongState:
      'Account state does not allow this action (it may be offline) — log in first',
    unauthenticated: 'Not signed in, or session expired',
    forbidden: 'Permission denied',
    rateLimited: 'Too many requests — try again later',
    dependencyUnavailable: 'A dependency is unavailable',
    transport: 'Network error — check your connection',
    unknown: 'Unknown error',
  },
  mutation: {
    partialFailed: '{{count}} failed',
    overflow: 'and {{count}} more not shown',
  },
  reasonCodes: {
    account_banned: 'Account banned',
    account_disabled: 'Account disabled',
    account_limited: 'Account limited',
    account_locked: 'Account locked',
    busy: 'Service busy',
    captcha_required: 'Captcha required',
    credentials_empty: 'Credentials empty',
    credentials_invalid: 'Credentials invalid',
    duplicate_request: 'Duplicate request',
    fx_refresh_db_write_failed: 'Failed to write the exchange rates to the database',
    fx_refresh_http_failed: 'Failed to request the exchange rates',
    guard_2fa_code: '2FA code required',
    guard_code_invalid: 'Invalid verification code',
    guard_device_confirm: 'Confirm the sign-in in the Steam app',
    guard_email_code: 'Email code required',
    guard_email_confirm: 'Confirm the sign-in by email',
    invalid_argument: 'Invalid request parameters',
    invalid_response: 'Malformed response',
    ip_banned: 'Egress IP banned',
    login_throttled: 'Sign-in throttled by risk control',
    network_unreachable: 'Network unreachable',
    no_credentials: 'No usable session credentials (relogin needed)',
    no_proxy_available: 'No proxy available',
    not_logged_on: 'Not signed in',
    pending: 'Pending',
    rate_limited: 'Rate limited',
    settle_refused: 'Settlement refused',
    ssrf_blocked: 'Blocked by the security policy',
    transport_error: 'Transport failure',
    transport_timeout: 'Transport timeout',
    unavailable: 'Service unavailable',
    unknown: 'Steam returned an unrecognised error code',
  },
  range: {
    today: 'Today',
    d7: 'Last 7 days',
    d30: 'Last 30 days',
    d90: 'Last 90 days',
    all: 'All time',
    from: 'From',
    to: 'To',
  },
  stats: {
    title: 'Statistics',
    totalScope: '{{count}} total',
    loadFailed: 'Failed to load statistics',
  },
  selectionBar: {
    idle: 'Nothing selected',
    clear: 'Clear selection',
    ariaLabel: 'Bulk actions',
  },
  app: {
    title: 'Steam Management',
    notFound: 'Page not found',
    forbidden: 'Access denied',
    theme: 'Theme',
    light: 'Light',
    dark: 'Dark',
    system: 'System',
    language: 'Language',
  },
};
